import _DTO from "./_DTO";


export default class RackDTO extends _DTO {

  constructor(rack) {
    super();
    this.id = rack.id;
  }

}
